export class Therapeut {

  static deserialize(dto: TherapeutDto): Therapeut {
    return new Therapeut(
      dto.id,
      dto.voornaam,
      dto.achternaam,
      dto.personeelsnummer,
      dto.email,
    );
  }

  static verwijderd(id: string, personeelsnummer: string): Therapeut {
    return new Therapeut(
      id,
      'Verwijderde therapeut',
      '',
      personeelsnummer,
      null,
      true,
    );
  }

  constructor(
    private id: string,
    private voornaam: string,
    private achternaam: string,
    private personeelsnummer: string,
    private email: string,
    private verwijderd: boolean = false,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getVoornaam(): string {
    return this.voornaam;
  }

  getAchternaam(): string {
    return this.achternaam;
  }

  getNaam(): string {
    return `${this.getAchternaam()} ${this.getVoornaam()}`;
  }

  getPersoneelsnummer(): string {
    return this.personeelsnummer;
  }

  getEmail(): string {
    return this.email;
  }

  isVerwijderd(): boolean {
    return this.verwijderd;
  }
}

export interface TherapeutDto {
  id: string;
  voornaam: string;
  achternaam: string;
  personeelsnummer: string;
  email: string;
}
